import { getWsUrl } from '../utils/js/endpoints'
import { leagueHelper } from './actionHelpers'

export const wsConnect = (league, gamecode) => {
    return {
        type: 'WS_CONNECT',
        url: `${getWsUrl(league)}/${league}/${gamecode}`,
        league,
        gamecode,
    }
}

export const wsConnected = () => {
    return {
        type: 'WS_CONNECTED',
    }
}

export const wsDisconnect = () => {
    return {
        type: 'WS_DISCONNECT',
    }
}

export const wsDisconnected = () => {
    return {
        type: 'WS_DISCONNECTED',
    }
}

export const wsMessageReceived = (gamedata, league) => {
    return leagueHelper(
        {
            type: 'WS_GAME_DATA_RECEIVED',
            gamedata: gamedata.data,
            receivedAt: Date.now(),
        },
        league,
        gamedata.data
    )
}

export const ajaxRequest = {
    type: 'AJAX_GAME_DATA_REQUEST',
}

export const ajaxReceived = (json, league, gamecode, window_location) => {
    return leagueHelper(
        {
            type: 'AJAX_GAME_DATA_RECEIVED',
            gamedata: json.game,
            league,
            gamecode,
            receivedAt: Date.now(),
            window_location,
        },
        league,
        json.game
    )
}

export const nhlVideoReceived = data => {
    return {
        type: 'NHL_VIDEO_DATA_RECEIVED',
        snClipsData: data.sn_clips,
        ighClipsData: data.igh_clips,
    }
}

export const tickerDataReceived = data => {
    return {
        type: 'TICKER_DATA_RECEIVED',
        data: data,
    }
}
